export default "__VITE_ASSET__CfEQPtoT__"